module.exports = __webpack_public_path__ + "img/InfoCenter.29656749.jpg";